export default {
  title: "",
  subtitle: "Information needed for registration (Person)",
  path: "person_registration",
  paragraphs: [
    "The following endpoint is used to register new customers, regardless of nationality. If a document number has been previously registered, the person's details will be updated. As soon as you send the request to register the customer, you will receive a response with their “subject_id”."
  ],
  image: {
    path: "/static/diagrams/customerRegistration.png"
  },
  request: {
    method: "POST",
    endpoint: "/subject/people",
    payload:{
      "person": {
        "document_number": "70590071050",
        "document_type": "cpf",
        "social_name": "Joaquim dos Santos",
        "email": "joaquim@email.com",
        "phone_country_code": "55",
        "phone_area_code": "18",
        "phone_number": "99812-1212",
        "birth_date": "2015-04-01",
        "net_monthly_average_income": "4000",
        "address_street": "Rua Barão do Rio Branco",
        "address_number": "310",
        "address_complement": "Apt. 44 A",
        "address_postal_code": "16201220",
        "address_city": "Birigui",
        "address_state": "SP",
        "address_country": "Brasil",
        "fiscal_country": "Brasil",
        "documents": [
          {
            "file_type": "application/pdf",
            "file_url": "http://somedomain.com/document-x.pdf",
            "labels": [
              "person-cpf"
            ]
          }
        ]
      }
    },
  },
  parameterPayload: [
    {
			name: "person",
			type: "object",
			required: true,
			description: "An object containing all the required values needed"
		},
    {
      name: "person.document_number",
      type: "string",
      required: true,
      description: "Customer’s national document number ",
      requiredFor: "All transactions",
    },
    {
      name: "person.document_type",
      type: "string",
      required: true,
      description: "Customer’s type of document ('cpf', 'curp', 'cc', 'ce', 'rut', 'passport')",
      requiredFor: "All transactions",
    },
    {
      name: "person.social_name",
      type: "string",
      required: true,
      description: "Customer’s full social name ",
      requiredFor: "All transactions",
    },
    {
      name: "person.fiscal_country",
      type: "string",
      required: true,
      description: "Customer’s fiscal country",
      requiredFor: "All transactions",
    },
    {
      name: "person.email",
      type: "string",
      required: false,
      description: "Customer's email",
      requiredFor: "All Cards, PSE and Boleto transactions"
    },
    {
			name: "person.website",
			type: "string",
			required: false,
			description: "Customer's website or related profile page"
		},
    {
      name: "person.phone_country_code",
      type: "string",
      required: false,
      description: "Country phones code (2 digits: BR +55; MX +52; CO +57; CL +52)",
      requiredFor: "All cards transactions in MXN and for PSE"
    },
    {
      name: "person.phone_area_code",
      type: "string",
      required: false,
      description: "Internal country area code",
      requiredFor: "PSE transactions"
    },
    {
      name: "person.phone_number",
      type: "string",
      required: false,
      description: "Customer's phone number",
      requiredFor: "All Cards, PSE and Boleto transactions"
    },
    {
      name: "person.birth_date",
      type: "string",
      required: false,
      description: "Customer’s birth date"
    },
    {
      name: "person.net_monthly_average_income",
      type: "string",
      required: false,
      description: "Customer's monthly average income"
    },
    {
      name: "person.address_street",
      type: "string",
      required: false,
      description: "Customer’s street name",
      requiredFor: "All cards, PSE and boleto transactions"
    },
    {
      name: "person.address_number",
      type: "string",
      required: false,
      description: "Customer’s house number",
      requiredFor: "All cards, PSE and boleto transactions"
    },
    {
      name: "person.address_complement",
      type: "string",
      required: false,
      description: "Customer’s block or apartment"
    },
    {
      name: "person.address_neighborhood",
      type: "string",
      required: false,
      description: "Customer’s neighborhood/district",
      requiredFor: "All cards, PSE and boleto transactions"
    },
    {
      name: "person.address_postal_code",
      type: "string",
      required: false,
      description: "Postal/zip code.",
      requiredFor: "All cards, PSE and boleto transactions"
    },
    {
      name: "person.address_city",
      type: "string",
      required: false,
      description: "Customer’s city name ",
      requiredFor: "All cards, PSE and boleto transactions"
    },
    {
    name: "person.address_state",
    type: "string",
    required: false,
    description: "Customer’s state of residence. In Brazil you’ll use only 2 letters : AC, AL, AP, AM, BA, CE, DF, ES, GO, MA, MT, MS, MG, PA, PB, PR, PE, PI, RJ, RN, RS, RO, RR, SC, SP, SE, TO.",
    requiredFor: "All cards, PSE and boleto transactions"
    },
    {
      name: "person.address_country",
      type: "string",
      required: false,
      description: "Customer’s country of residence",
      requiredFor: "All cards, PSE and boleto transactions"
    },
    {
      name: "person.documents",
      type: "array",
      required: false,
      description: "An array of documents related to the Customer (Customers who operate above a threshold value per month or exceed a cumulative limit in the last 12 months of operation must have the following associated documents: 'rg-number', 'cpf-number', 'rg-photo', 'address-proof', 'revenue-tax-declaration').",
      is_parent: true,
      requiredFor: "Customers who exceeds 20k USD annually in their amount of transactions"
    },
		{
			name: "person.documents.labels",
			type: "array",
			required: false,
			description: "Keywords that may help identify the document in the person registration tab.",
      requiredFor: "When sending documents field"
		},
		{
			name: "person.documents.file_type",
			type: "string",
			required: false,
			description: "Document file MIME type. Must match the document type.",
      requiredFor: "When sending documents field"
		},
		{
			name: "person.documents.file_data",
			type: "string",
			required: false,
			description: "Document file encoded in Base64.",
      requiredFor: "When sending documents and using the file_data"
		},
    {
      name: "person.documents.file_name",
      type: "string",
      required: false,
      description: "Name which the file will be stored.",
      requiredFor: "When sending documents field and using the file_data"
    },
		{
			name: "person.documents.file_url",
			type: "string",
			required: false,
			description: "Public URL pointing to the document. Note that it must start with http:// or https://",
      requiredFor: "When sending documents and using a URL"
		}
  ],
  troubleshooting: {
    title: 'Common mistakes',
    messages: [
      {
        code: {
          "errors": {
            "document_number": [
              "invalid"
            ]
          }
        },
        solution: 'Please provide a valid document number without dots or dashes. This field is validated when using all document types accepted by the API ("cpf", "curp", "cc", "ce", "rut", "passport") as the document type. As some example, you can generate a valid CPF using this website: "https://www.4devs.com.br/gerador_de_cpf". You can also create a valid CURP/RFC document number using this website: "https://datafakegenerator.com/genrfc"'
      },
      {
        code: 'Bad Request(400)',
        solution: 'Make sure all required fields are present in your request.'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/components/documentation/data/SubjectPeople/PersonRegistration.js